import { LANDING_PAGE_STATUS } from '../consts/landingPageStatus';

const URL = 'https://knowbetterplanbetter.com/landing-page/';
const PREVIEW_URL = 'https://kbpb-sandbox.taboola-content-affiliation.com/landing-page?preview=true&page=';

export const getLandingPageUrl = ({ accountId, slug, status, isPreview = false }) => {
    const baseUrl = isPreview ? PREVIEW_URL : URL;
    const folder = isPreview || status === LANDING_PAGE_STATUS.DRAFT ? `/${status?.toLowerCase()}` : '';

    return `${baseUrl}${accountId}${folder}/${slug}`;
};
